import axios from '../../util/Api';
import React, { useState, useEffect, useContext } from 'react';
import Auxiliary from '../../util/Auxiliary';
import Table from '../../components/Table/Basic';
import { ParamsContext } from '../Context/ParamsContext';
import { Switch } from 'antd';
import Edit from './Edit';

const List = () => {
  const [loading, setLoading] = useState(true);
  const [skills, setSkills] = useState([]);
  const [total, setTotal] = useState(null);
  const params = useContext(ParamsContext);

  const [loadingCategory, setLoadingCategory] = useState(true);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchSkills();
  }, [params]);

  const fetchSkills = () => {
    setLoading(true);
    const url = `/skills`;
    axios.get(url, { params: params }).then(resp => {
      setSkills(resp.data.skills);
      setTotal(resp.data.total);
      setLoading(false);
    }).catch(err => {});
  }

  useEffect(() => {
    setLoadingCategory(true);
    const url = `/skills/categories`;
    axios.get(url).then(resp => {
      const options = resp.data.reduce((obj, item) => {
        return [...obj, { value: item.id, label: item.name }];
      },[]);
      setCategories(options);
      setLoadingCategory(false);
    }).catch(err => {});
  }, []);

  const columns = [
    {
      title: 'Nama',
      dataIndex: 'name',
      key: 'name',
      filter: true,
      sorter: true,
    },
    {
      title: 'Kategori',
      dataIndex: 'category',
      key: 'category',
      filter: true,
      render: category => category.name,
      filterOptions: loadingCategory ? [] : [{ value: '', label: 'Semua' }, ...categories],
    },
    {
      title: 'Status',
      key: 'status',
      sorter: true,
      render: record => {
        return record.status.label;
      }
    },
    {
      title: '',
      render: record => {
        return <Edit skill={record} />;
      }
    }
  ];
  return (
    <Auxiliary>
      <Table
        columns={columns}
        dataSource={skills}
        loading={loading}
        total={total}
      />
    </Auxiliary>
  );
}

export default List;